import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-widest text-primary-600">
            常见问题
          </p>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            关于缓存与离线阅读的疑问
          </h2>
          <p className="mt-4 text-base text-foreground-600">
            使用洒洒漫画网过程中遇到的小疑问，这里都有答案。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <h3 className="flex items-center gap-3 text-sm font-bold text-foreground-900 md:text-base">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-900">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </h3>
                  <i
                    className={`shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                      open ? "ri-subtract-line rotate-0" : "ri-add-line"
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}